import { posthog } from '@/analytics/posthog'

const STORAGE_KEY = 'ode-consent-v2'

function hasAnalyticsConsent(): boolean {
  if (typeof window === 'undefined') return false
  const raw = window.localStorage.getItem(STORAGE_KEY)
  if (!raw) return false
  try {
    const parsed = JSON.parse(raw) as { analytics?: boolean }
    return parsed?.analytics === true
  } catch {
    return false
  }
}

export type EventName =
  | 'hero_cta_clicked'
  | 'hero_secondary_cta_clicked'
  | 'feature_block_visible'
  | 'news_card_clicked'
  | 'newsletter_submitted'
  | 'early_access_submitted'
  | 'locale_switched'

export function track(event: EventName, props: Record<string, unknown> = {}) {
  if (!hasAnalyticsConsent()) return
  posthog.capture(event, props)
}
